import React, { Component, Fragment } from "react";
import NomeUnidade from "../../../UI/NomeUnidade";
import Card from "../Elementos/Card";
import "../../styleSTI.css";
import MenuSTI from "../../../STI/Dashboard/Elementos/MenuSTI";
import Select from "../Elementos/Select";

export default class PageDashboard extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Dashboard",
            resultados: [],
            resultadosV2: [],
            escolheDash: true
        }
    }

    render() {
        return(
            <Fragment>
                <div className="content">
                    <NomeUnidade unidade={"Relatórios STI"} />
                    <div className="row">
                        <div className="col-md-12 ml-auto mr-auto">
                            <MenuSTI />
                        </div>
                    </div>
                    <Card />
                </div>
            </Fragment>
        )
    }
}